import { render, staticRenderFns } from "./ProfileOder.vue?vue&type=template&id=73ef1146&scoped=true&"
import script from "./ProfileOder.vue?vue&type=script&lang=js&"
export * from "./ProfileOder.vue?vue&type=script&lang=js&"
import style0 from "./ProfileOder.vue?vue&type=style&index=0&id=73ef1146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ef1146",
  null
  
)

export default component.exports